import React from 'react';
import ReactDOM from 'react-dom/client';
import 'babel-polyfill';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './common/styles/frame.less';
require('es6-promise').polyfill();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <App />
);

{/* <React.StrictMode>
  // 去除严格模式高阶组件
  <App />
</React.StrictMode> */}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
